import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FooterComponent } from "./footer.component";
import { MaterialModule } from "src/app/material.module";
import { FlexLayoutModule } from "@angular/flex-layout";
import { RouterModule } from "@angular/router";
import { TermsPrivacyComponent } from "./terms-privacy/terms-privacy.component";
import {
  MatToolbarModule,
  MatBottomSheetModule,
  MatBottomSheetConfig
} from "@angular/material";

@NgModule({
  declarations: [FooterComponent, TermsPrivacyComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    RouterModule,
    MatToolbarModule,
    MatBottomSheetModule,
  ],
  exports: [FooterComponent],
  entryComponents: [TermsPrivacyComponent],
  providers: [
    {
      provide: MatBottomSheetConfig,
      useValue: { hasBackdrop: false }
    }
  ]
})
export class FooterModule {}
